// import React, { useState } from 'react';
// import {
//   FolderTree,
//   Move,
//   ChevronDown,
//   Sparkles,
//   Eye,
//   ArrowRight,
//   Check,
//   X,
//   FolderOpen,
//   Copy
// } from 'lucide-react';

// export default function NavigateLikeFileSystem() {
//   // State for selected documents
//   const [selectedDocs, setSelectedDocs] = useState([]);
//   const [documents, setDocuments] = useState([
//     {
//       id: 1,
//       name: 'Invoice_Q4_2024.pdf',
//       emoji: '📄',
//       tags: ['Clients', 'ZIAAT', 'FY 25-26', 'GST', 'GSTR-3B'],
//       type: 'PDF',
//       checked: false
//     },
//     {
//       id: 2,
//       name: 'Tax_Returns_Final.pdf',
//       emoji: '📄',
//       tags: ['Clients', 'ZIAAT', 'FY 25-26', 'Income Tax'],
//       type: 'PDF',
//       checked: false
//     },
//     {
//       id: 3,
//       name: 'Audit_Report_2024.pdf',
//       emoji: '📄',
//       tags: ['Clients', 'ZIAAT', 'FY 25-26', 'Audit'],
//       type: 'PDF',
//       checked: false
//     },
//     {
//       id: 4,
//       name: 'Contract_Agreement.docx',
//       emoji: '📝',
//       tags: ['Legal', 'Contracts', 'FY 25-26'],
//       type: 'DOCX',
//       checked: false
//     },
//     {
//       id: 5,
//       name: 'Budget_Planning.xlsx',
//       emoji: '📊',
//       tags: ['Finance', 'Planning', 'FY 25-26'],
//       type: 'XLSX',
//       checked: false
//     }
//   ]);

//   // State for move functionality
//   const [isMoveDialogOpen, setIsMoveDialogOpen] = useState(false);
//   const [selectedDestination, setSelectedDestination] = useState('');
//   const [availableFolders, setAvailableFolders] = useState([
//     { id: 'archive', name: 'Archive', path: '/Archive' },
//     { id: 'clients', name: 'Clients', path: '/Clients' },
//     { id: 'finance', name: 'Finance', path: '/Finance' },
//     { id: 'legal', name: 'Legal', path: '/Legal' },
//     { id: 'reports', name: 'Reports', path: '/Reports' },
//     { id: 'tax', name: 'Tax Documents', path: '/Tax' },
//   ]);
//   const [newFolderName, setNewFolderName] = useState('');
//   const [showNewFolderInput, setShowNewFolderInput] = useState(false);
//   const isMobile = window.innerWidth < 768;
//   // Handle document selection
//   const handleCheckboxChange = (id) => {
//     const updatedDocs = documents.map(doc => {
//       if (doc.id === id) {
//         return { ...doc, checked: !doc.checked };
//       }
//       return doc;
//     });

//     setDocuments(updatedDocs);

//     const selectedIds = updatedDocs
//       .filter(doc => doc.checked)
//       .map(doc => doc.id);

//     setSelectedDocs(selectedIds);
//   };

//   // Select all documents
//   const handleSelectAll = () => {
//     const allChecked = documents.every(doc => doc.checked);
//     const updatedDocs = documents.map(doc => ({
//       ...doc,
//       checked: !allChecked
//     }));

//     setDocuments(updatedDocs);
//     setSelectedDocs(!allChecked ? documents.map(doc => doc.id) : []);
//   };

//   // Clear all selections
//   const handleClearSelection = () => {
//     const updatedDocs = documents.map(doc => ({
//       ...doc,
//       checked: false
//     }));

//     setDocuments(updatedDocs);
//     setSelectedDocs([]);
//   };

//   // Move selected documents
//   const handleMoveDocuments = () => {
//     if (selectedDocs.length === 0) return;

//     if (!selectedDestination && !newFolderName.trim()) {
//       alert('Please select a destination folder or create a new one.');
//       return;
//     }

//     const destination = selectedDestination || `/New/${newFolderName.trim()}`;

//     // Show confirmation and move
//     const confirmMove = window.confirm(
//       `Move ${selectedDocs.length} document(s) to "${destination}"?`
//     );

//     if (confirmMove) {
//       // In a real app, you would make an API call here
//       console.log(`Moving documents ${selectedDocs.join(', ')} to ${destination}`);

//       // Reset state
//       setSelectedDocs([]);
//       setSelectedDestination('');
//       setNewFolderName('');
//       setShowNewFolderInput(false);

//       // Uncheck all documents
//       const updatedDocs = documents.map(doc => ({
//         ...doc,
//         checked: false
//       }));
//       setDocuments(updatedDocs);

//       // Close dialog
//       setIsMoveDialogOpen(false);

//       // Show success message
//       alert(`${selectedDocs.length} document(s) moved successfully to ${destination}!`);
//     }
//   };

//   // Create new folder
//   const handleCreateNewFolder = () => {
//     if (!newFolderName.trim()) {
//       alert('Please enter a folder name.');
//       return;
//     }

//     const newFolder = {
//       id: `folder-${Date.now()}`,
//       name: newFolderName.trim(),
//       path: `/New/${newFolderName.trim()}`
//     };

//     setAvailableFolders(prev => [...prev, newFolder]);
//     setSelectedDestination(newFolder.path);
//     setNewFolderName('');
//     setShowNewFolderInput(false);
//   };

//   // Render document card
//   // const renderDocumentCard = (doc) => (
//   //   <>
//   //     <div
//   //       key={doc.id + "-desktop"}
//   //       className={`hidden md:block items-center gap-4 bg-white rounded-xl p-5 border transition-all cursor-pointer ${doc.checked
//   //         ? 'border-cyan-500 bg-cyan-50/30 shadow-sm'
//   //         : 'border-gray-200 hover:border-gray-300'
//   //         }`}
//   //       onClick={(e) => {
//   //         // Don't trigger when clicking on checkbox or buttons
//   //         if (!e.target.closest('input') && !e.target.closest('button')) {
//   //           handleCheckboxChange(doc.id);
//   //         }
//   //       }}
//   //     >
//   //       <input
//   //         type="checkbox"
//   //         className="w-5 h-5 rounded cursor-pointer accent-cyan-500"
//   //         checked={doc.checked}
//   //         onChange={(e) => {
//   //           e.stopPropagation();
//   //           handleCheckboxChange(doc.id);
//   //         }}
//   //       />

//   //       <div className="text-2xl">{doc.emoji}</div>

//   //       <div className="flex-1">
//   //         <p className="text-gray-900 font-medium mb-2">{doc.name}</p>

//   //         <div className="flex items-center gap-2 flex-wrap">
//   //           {doc.tags.map((tag, index) => (
//   //             <div key={index} className="flex items-center gap-2">
//   //               <span className="text-xs px-3 py-1 rounded-full bg-gray-100 text-gray-600">
//   //                 {tag}
//   //               </span>
//   //               {index < doc.tags.length - 1 && (
//   //                 <ChevronDown className="w-3 h-3 text-gray-400 rotate-[-90deg]" />
//   //               )}
//   //             </div>
//   //           ))}
//   //         </div>
//   //       </div>

//   //       <span className="text-sm text-gray-500 px-3 py-1 bg-gray-100 rounded-lg">
//   //         {doc.type}
//   //       </span>

//   //       <button
//   //         className="p-2 text-gray-400 hover:text-cyan-600 transition-colors"
//   //         onClick={(e) => {
//   //           e.stopPropagation();
//   //           // Quick preview functionality
//   //           alert(`Quick preview of ${doc.name}`);
//   //         }}
//   //         title="Quick Preview"
//   //       >
//   //         <Eye className="w-4 h-4" />
//   //       </button>
//   //     </div>
//   //     <div
//   //       key={doc.id + "-mobile"}
//   //       className={`DocItem ${doc.checked ? 'is-checked' : ''}`}
//   //       onClick={(e) => {
//   //         if (!e.target.closest('input') && !e.target.closest('button')) {
//   //           handleCheckboxChange(doc.id);
//   //         }
//   //       }}
//   //     >
//   //       <input
//   //         type="checkbox"
//   //         className="DocItem_Checkbox"
//   //         checked={doc.checked}
//   //         onChange={(e) => {
//   //           e.stopPropagation();
//   //           handleCheckboxChange(doc.id);
//   //         }}
//   //       />

//   //       <div className="DocItem_Emoji">{doc.emoji}</div>

//   //       <div className="DocItem_Content">
//   //         <p className="DocItem_Title">{doc.name}</p>

//   //         <div className="DocItem_Tags">
//   //           {doc.tags.map((tag, index) => (
//   //             <div key={index} className="DocItem_TagWrap">
//   //               <span className="DocItem_Tag">{tag}</span>
//   //               {index < doc.tags.length - 1 && (
//   //                 <ChevronDown className="DocItem_TagArrow" />
//   //               )}
//   //             </div>
//   //           ))}
//   //         </div>
//   //       </div>

//   //       <span className="DocItem_Type">{doc.type}</span>

//   //       <button
//   //         className="DocItem_PreviewBtn"
//   //         onClick={(e) => {
//   //           e.stopPropagation();
//   //           alert(`Quick preview of ${doc.name}`);
//   //         }}
//   //         title="Quick Preview"
//   //       >
//   //         <Eye className="DocItem_PreviewIcon" />
//   //       </button>
//   //     </div>

//   //   </>
//   // );
//   const renderDocumentCard = (doc) => {

//     // ✅ DESKTOP VERSION
//     return (
//       <div>

//         <div
//           key={doc.id}
//           className={`items-center gap-4 bg-white rounded-xl p-5 border transition-all cursor-pointer docs_Web
//         ${doc.checked ? 'border-cyan-500 bg-cyan-50/30 shadow-sm' : 'border-gray-200 hover:border-gray-300'}
//       `}
//           onClick={(e) => {
//             if (!e.target.closest('input') && !e.target.closest('button')) {
//               handleCheckboxChange(doc.id);
//             }
//           }}
//         >
//           <input
//             type="checkbox"
//             className="w-5 h-5 accent-cyan-500"
//             checked={doc.checked}
//             onChange={(e) => {
//               e.stopPropagation();
//               handleCheckboxChange(doc.id);
//             }}
//           />

//           <div className="text-2xl">{doc.emoji}</div>

//           <div className="flex-1">
//             <p className="text-gray-900 font-medium mb-2">{doc.name}</p>
//             <div className="flex gap-2 flex-wrap">
//               {doc.tags.map((tag, index) => (
//                 <span key={index} className="text-xs px-3 py-1 rounded-full bg-gray-100 text-gray-600">
//                   {tag}
//                 </span>
//               ))}
//             </div>
//           </div>

//           <span className="text-sm text-gray-500 px-3 py-1 bg-gray-100 rounded-lg">
//             {doc.type}
//           </span>

//           <button
//             className="p-2 text-gray-400 hover:text-cyan-600"
//             onClick={(e) => {
//               e.stopPropagation();
//               alert(`Quick preview of ${doc.name}`);
//             }}
//           >
//             <Eye className="w-4 h-4" />
//           </button>
//         </div>
//         <div
//           key={doc.id}
//           className={`DocItem ${doc.checked ? 'is-checked' : ''}`}
//           onClick={(e) => {
//             if (!e.target.closest('input') && !e.target.closest('button')) {
//               handleCheckboxChange(doc.id);
//             }
//           }}
//         >
//           <input
//             type="checkbox"
//             className="DocItem_Checkbox"
//             checked={doc.checked}
//             onChange={(e) => {
//               e.stopPropagation();
//               handleCheckboxChange(doc.id);
//             }}
//           />

//           <div className="DocItem_Emoji">{doc.emoji}</div>

//           <div className="DocItem_Content">
//             <p className="DocItem_Title">{doc.name}</p>

//             <div className="DocItem_Tags">
//               {doc.tags.map((tag, index) => (
//                 <span key={index} className="DocItem_Tag">{tag}
//                   {/* {console.log('Tag', tag)} */}
//                 </span>
//               ))}
//             </div>
//           </div>

//           <span className="DocItem_Type">{doc.type}</span>

//           <button
//             className="DocItem_PreviewBtn"
//             onClick={(e) => {
//               e.stopPropagation();
//               alert(`Quick preview of ${doc.name}`);
//             }}
//           >
//             <Eye className="DocItem_PreviewIcon" />
//           </button>
//         </div>
//       </div>
//     );
//   };
//   // const renderDocumentCard = (doc) => {
//   //   if (isMobile) {
//   //     // ✅ MOBILE VERSION
//   //     return (
//   //       <div
//   //         key={doc.id}
//   //         className={`DocItem ${doc.checked ? 'is-checked' : ''}`}
//   //         onClick={(e) => {
//   //           if (!e.target.closest('input') && !e.target.closest('button')) {
//   //             handleCheckboxChange(doc.id);
//   //           }
//   //         }}
//   //       >
//   //         <input
//   //           type="checkbox"
//   //           className="DocItem_Checkbox"
//   //           checked={doc.checked}
//   //           onChange={(e) => {
//   //             e.stopPropagation();
//   //             handleCheckboxChange(doc.id);
//   //           }}
//   //         />

//   //         <div className="DocItem_Emoji">{doc.emoji}</div>

//   //         <div className="DocItem_Content">
//   //           <p className="DocItem_Title">{doc.name}</p>

//   //           <div className="DocItem_Tags">
//   //             {doc.tags.map((tag, index) => (
//   //               <span key={index} className="DocItem_Tag">{tag}
//   //                 {/* {console.log('Tag', tag)} */}
//   //               </span>
//   //             ))}
//   //           </div>
//   //         </div>

//   //         <span className="DocItem_Type">{doc.type}</span>

//   //         <button
//   //           className="DocItem_PreviewBtn"
//   //           onClick={(e) => {
//   //             e.stopPropagation();
//   //             alert(`Quick preview of ${doc.name}`);
//   //           }}
//   //         >
//   //           <Eye className="DocItem_PreviewIcon" />
//   //         </button>
//   //       </div>
//   //     );
//   //   }

//   //   // ✅ DESKTOP VERSION
//   //   return (
//   //     <div
//   //       key={doc.id}
//   //       className={`flex items-center gap-4 bg-white rounded-xl p-5 border transition-all cursor-pointer
//   //       ${doc.checked ? 'border-cyan-500 bg-cyan-50/30 shadow-sm' : 'border-gray-200 hover:border-gray-300'}
//   //     `}
//   //       onClick={(e) => {
//   //         if (!e.target.closest('input') && !e.target.closest('button')) {
//   //           handleCheckboxChange(doc.id);
//   //         }
//   //       }}
//   //     >
//   //       <input
//   //         type="checkbox"
//   //         className="w-5 h-5 accent-cyan-500"
//   //         checked={doc.checked}
//   //         onChange={(e) => {
//   //           e.stopPropagation();
//   //           handleCheckboxChange(doc.id);
//   //         }}
//   //       />

//   //       <div className="text-2xl">{doc.emoji}</div>

//   //       <div className="flex-1">
//   //         <p className="text-gray-900 font-medium mb-2">{doc.name}</p>
//   //         <div className="flex gap-2 flex-wrap">
//   //           {doc.tags.map((tag, index) => (
//   //             <span key={index} className="text-xs px-3 py-1 rounded-full bg-gray-100 text-gray-600">
//   //               {tag}
//   //             </span>
//   //           ))}
//   //         </div>
//   //       </div>

//   //       <span className="text-sm text-gray-500 px-3 py-1 bg-gray-100 rounded-lg">
//   //         {doc.type}
//   //       </span>

//   //       <button
//   //         className="p-2 text-gray-400 hover:text-cyan-600"
//   //         onClick={(e) => {
//   //           e.stopPropagation();
//   //           alert(`Quick preview of ${doc.name}`);
//   //         }}
//   //       >
//   //         <Eye className="w-4 h-4" />
//   //       </button>
//   //     </div>
//   //   );
//   // };

//   return (
//     <section className="Navigate_section">
//       <div className="max-w-7xl mx-auto">
//         <div className="relative">
//           {/* Header */}
//           <div className="text-center Navigate_mrg">
//             <div>
//               {/* <div className="inline-flex items-center gap-2 bg-gradient-to-r from-cyan-500/20 to-cyan-600/20 border border-cyan-500/30 px-5 py-2 rounded-full mb-8">
//                 <FolderTree className="w-4 h-4 text-cyan-400" />
//                 <span className="text-sm text-cyan-700">Path-Based Organization</span>
//               </div> */}
//               <div className="Navigate_Badge">
//                 <FolderTree className="Navigate_BadgeIcon" />
//                 <span className="Navigate_BadgeText">Path-Based Organization</span>
//               </div>
//               <h2 className="Navigate_Title">
//                 Navigate Like<br />
//                 <span className="Navigate_TitleGradient">
//                   Your File System.
//                 </span>
//               </h2>

//               <p className="Navigate_Description">
//                 Familiar folder paths. Powerful organization. Move documents anywhere with precision.
//               </p>

//             </div>
//           </div>

//           {/* Main Document Management Panel */}
//           <div className="DocsPanel">
//             {/* Panel Header */}
//             <div className="DocsPanel_Header">
//               <div className="DocsPanel_HeaderRow">
//                 <div>
//                   <h3 className="DocsPanel_Title">Your Documents</h3>
//                   <p className="DocsPanel_Subtitle">
//                     {selectedDocs.length > 0
//                       ? `${selectedDocs.length} document(s) selected`
//                       : 'Select documents to move them'}
//                   </p>
//                 </div>

//                 <div className="DocsPanel_Actions">
//                   {/* Select All / Clear */}
//                   {documents.length > 0 && (
//                     <button
//                       onClick={selectedDocs.length > 0 ? handleClearSelection : handleSelectAll}
//                       className="DocsPanel_ActionBtn DocsPanel_ActionBtn--secondary"
//                     >
//                       {selectedDocs.length > 0 ? 'Clear Selection' : 'Select All'}
//                     </button>
//                   )}

//                   {/* Move Button */}
//                   <button
//                     onClick={() => setIsMoveDialogOpen(true)}
//                     disabled={selectedDocs.length === 0}
//                     className={`DocsPanel_ActionBtn DocsPanel_ActionBtn--primary ${selectedDocs.length === 0 ? 'is-disabled' : ''
//                       }`}
//                   >
//                     <Move className="DocsPanel_ActionIcon" />
//                     <span>Move Selected ({selectedDocs.length})</span>
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Documents List */}
//             <div className="DocsPanel_List">
//               {documents.map(renderDocumentCard)}
//             </div>
//           </div>

//           {/* Features Grid */}
//           <div className="mt-12 grid md:grid-cols-4 gap-6">
//             <div className="bg-gradient-to-b from-white to-gray-50 rounded-xl
//             p-6 border border-gray-200 text-center group hover:border-cyan-500/30 hover:shadow-lg hover:shadow-cyan-500/5 transition-all Features_Grid_Card">
//               <div>
//                 <FolderTree className="w-8 h-8 text-cyan-600 mx-auto mb-3 group-hover:text-cyan-500 transition-colors" />
//               </div>
//               <p className="text-gray-900 mb-1 font-medium">Visual Tree</p>
//               <p className="text-sm text-gray-500">Navigate with precision</p>
//             </div>

//             <div className="bg-gradient-to-b from-white to-gray-50 rounded-xl
//              p-6 border border-gray-200 text-center group hover:border-cyan-500/30 hover:shadow-lg hover:shadow-cyan-500/5 transition-all Features_Grid_Card">
//               <div>
//                 <Sparkles className="w-8 h-8 text-cyan-600 mx-auto mb-3 group-hover:text-cyan-500 transition-colors" />
//               </div>
//               <p className="text-gray-900 mb-1 font-medium">Smooth Animations</p>
//               <p className="text-sm text-gray-500">Delightful interactions</p>
//             </div>

//             <div className="bg-gradient-to-b from-white to-gray-50 rounded-xl
//              p-6 border border-gray-200 text-center group hover:border-cyan-500/30 hover:shadow-lg hover:shadow-cyan-500/5 transition-all Features_Grid_Card">
//               <div>
//                 <Eye className="w-8 h-8 text-cyan-600 mx-auto mb-3 group-hover:text-cyan-500 transition-colors" />
//               </div>
//               <p className="text-gray-900 mb-1 font-medium">Clear Paths</p>
//               <p className="text-sm text-gray-500">Always know where you are</p>
//             </div>

//             <div className="bg-gradient-to-b from-white to-gray-50 rounded-xl
//             p-6 border border-gray-200 text-center group hover:border-cyan-500/30 hover:shadow-lg hover:shadow-cyan-500/5 transition-all Features_Grid_Card">
//               <div>
//                 <ArrowRight className="w-8 h-8 text-cyan-600 mx-auto mb-3 group-hover:text-cyan-500 transition-colors" />
//               </div>
//               <p className="text-gray-900 mb-1 font-medium">One-Click Move</p>
//               <p className="text-sm text-gray-500">Instant organization</p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Move Dialog Modal */}
//       {isMoveDialogOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/50 backdrop-blur-sm">
//           <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl p-6">
//             <div className="flex items-center justify-between mb-6">
//               <h3 className="text-xl font-semibold text-gray-900">
//                 Move {selectedDocs.length} Document(s)
//               </h3>
//               <button
//                 onClick={() => setIsMoveDialogOpen(false)}
//                 className="text-gray-400 hover:text-gray-600"
//               >
//                 <X className="w-5 h-5" />
//               </button>
//             </div>

//             <div className="space-y-4">
//               {/* Available Folders */}
//               <div>
//                 <label className="text-sm font-medium text-gray-700 mb-2 block">
//                   Select Destination Folder
//                 </label>
//                 <div className="space-y-2 max-h-60 overflow-y-auto pr-2">
//                   {availableFolders.map(folder => (
//                     <div
//                       key={folder.id}
//                       onClick={() => {
//                         setSelectedDestination(folder.path);
//                         setShowNewFolderInput(false);
//                       }}
//                       className={`flex items-center gap-3 p-3 rounded-lg cursor-pointer transition-colors ${selectedDestination === folder.path
//                         ? 'bg-cyan-50 border border-cyan-200'
//                         : 'hover:bg-gray-50 border border-gray-200'
//                         }`}
//                     >
//                       <FolderOpen className={`w-4 h-4 ${selectedDestination === folder.path
//                         ? 'text-cyan-600'
//                         : 'text-gray-400'
//                         }`} />
//                       <div className="flex-1">
//                         <p className="text-gray-900">{folder.name}</p>
//                         <p className="text-xs text-gray-500">{folder.path}</p>
//                       </div>
//                       {selectedDestination === folder.path && (
//                         <Check className="w-4 h-4 text-cyan-600" />
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Create New Folder */}
//               <div>
//                 <button
//                   onClick={() => {
//                     setShowNewFolderInput(!showNewFolderInput);
//                     setSelectedDestination('');
//                   }}
//                   className="w-full flex items-center justify-center gap-2 p-3 text-cyan-600 hover:text-cyan-700 hover:bg-cyan-50 rounded-lg border border-dashed border-cyan-300 transition-colors"
//                 >
//                   <FolderTree className="w-4 h-4" />
//                   Create New Folder
//                 </button>

//                 {showNewFolderInput && (
//                   <div className="mt-3 space-y-3">
//                     <input
//                       type="text"
//                       value={newFolderName}
//                       onChange={(e) => setNewFolderName(e.target.value)}
//                       placeholder="Enter folder name"
//                       className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
//                     />
//                     <div className="flex gap-2">
//                       <button
//                         onClick={handleCreateNewFolder}
//                         className="flex-1 px-4 py-2 bg-cyan-500 text-white rounded-lg hover:bg-cyan-600 transition-colors"
//                       >
//                         Create Folder
//                       </button>
//                       <button
//                         onClick={() => {
//                           setShowNewFolderInput(false);
//                           setNewFolderName('');
//                         }}
//                         className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
//                       >
//                         Cancel
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>

//               {/* Action Buttons */}
//               <div className="flex gap-3 pt-4 border-t border-gray-200">
//                 <button
//                   onClick={handleMoveDocuments}
//                   disabled={selectedDocs.length === 0 || (!selectedDestination && !newFolderName.trim())}
//                   className={`flex-1 px-4 py-3 rounded-lg flex items-center justify-center gap-2 font-medium ${selectedDocs.length > 0 && (selectedDestination || newFolderName.trim())
//                     ? 'bg-cyan-500 text-white hover:bg-cyan-600'
//                     : 'bg-gray-200 text-gray-400 cursor-not-allowed'
//                     }`}
//                 >
//                   <Move className="w-4 h-4" />
//                   Move Documents
//                 </button>
//                 <button
//                   onClick={() => setIsMoveDialogOpen(false)}
//                   className="px-4 py-3 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Custom Scrollbar Styles */}
//       <style jsx>{`
//         .custom-scrollbar::-webkit-scrollbar {
//           width: 8px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-track {
//           background: rgba(255, 255, 255, 0.05);
//           border-radius: 10px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-thumb {
//           background: rgba(6, 182, 212, 0.3);
//           border-radius: 10px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-thumb:hover {
//           background: rgba(6, 182, 212, 0.5);
//         }
//       `}</style>
//     </section>
//   );
// }
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion"; // or 'motion/react'
import {
  FolderTree,
  Move,
  ChevronDown,
  Sparkles,
  Eye,
  ArrowRight,
  Check,
  X,
  FolderOpen,
  Copy,
  Users,
  User,
  Building,
  Search,
} from "lucide-react";
// css start from 337 in my_custom.css
export default function NavigateLikeFileSystem() {
  // ---------- Document state (now with path instead of tags) ----------
  const [documents, setDocuments] = useState([
    {
      id: 1,
      name: "Invoice_Q4_2024.pdf",
      emoji: "📄",
      path: ["Clients", "ZIAAT", "FY 25-26", "GST", "GSTR-3B"],
      type: "PDF",
      checked: false,
    },
    {
      id: 2,
      name: "Tax_Returns_Final.pdf",
      emoji: "📄",
      path: ["Clients", "ZIAAT", "FY 25-26", "Income Tax"],
      type: "PDF",
      checked: false,
    },
    {
      id: 3,
      name: "Audit_Report_2024.pdf",
      emoji: "📄",
      path: ["Clients", "ZIAAT", "FY 25-26", "Audit"],
      type: "PDF",
      checked: false,
    },
    {
      id: 4,
      name: "Contract_Agreement.docx",
      emoji: "📝",
      path: ["Legal", "Contracts", "FY 25-26"],
      type: "DOCX",
      checked: false,
    },
    {
      id: 5,
      name: "Budget_Planning.xlsx",
      emoji: "📊",
      path: ["Finance", "Planning", "FY 25-26"],
      type: "XLSX",
      checked: false,
    },
  ]);

  const [selectedDocs, setSelectedDocs] = useState([]);

  // ---------- Move dialog state (theater mode) ----------
  const [showMoveDialog, setShowMoveDialog] = useState(false);
  const [expandedFolders, setExpandedFolders] = useState([
    "root",
    "clients",
    "ziaat",
    "fy25-26",
    "gst",
    "gstr3b",
  ]);
  const [selectedFolder, setSelectedFolder] = useState("gstr3b");
  const [folderSearchQuery, setFolderSearchQuery] = useState("");
  const [quickAccessTab, setQuickAccessTab] = useState("clients");
  const [hoveredFolder, setHoveredFolder] = useState(null);
  const [movingDocs, setMovingDocs] = useState(false);

  // ---------- Sequential reveal ----------
  const [showSequentialReveal, setShowSequentialReveal] = useState(false);
  const [revealStep, setRevealStep] = useState("complex");

  // ---------- Folder structure (matches your document paths) ----------
  const folderStructure = {
    root: {
      id: "root",
      name: "Root",
      children: ["users", "clients", "office"],
    },
    users: {
      id: "users",
      name: "Users",
      parent: "root",
      children: ["personal-docs", "certificates"],
    },
    "personal-docs": {
      id: "personal-docs",
      name: "Personal Documents",
      parent: "users",
      children: [],
    },
    certificates: {
      id: "certificates",
      name: "Certificates",
      parent: "users",
      children: [],
    },
    clients: {
      id: "clients",
      name: "Clients",
      parent: "root",
      children: ["ziaat", "acme-corp", "techstart"],
    },
    ziaat: {
      id: "ziaat",
      name: "ZIAAT TECHNOLABS",
      parent: "clients",
      children: ["fy25-26", "fy24-25"],
    },
    "acme-corp": {
      id: "acme-corp",
      name: "ACME Corporation",
      parent: "clients",
      children: [],
    },
    techstart: {
      id: "techstart",
      name: "TechStart Inc.",
      parent: "clients",
      children: [],
    },
    "fy25-26": {
      id: "fy25-26",
      name: "FY 25-26",
      parent: "ziaat",
      children: ["income-tax", "gst", "audit"],
    },
    "fy24-25": {
      id: "fy24-25",
      name: "FY 24-25",
      parent: "ziaat",
      children: [],
    },
    "income-tax": {
      id: "income-tax",
      name: "Income Tax",
      parent: "fy25-26",
      children: [],
    },
    gst: {
      id: "gst",
      name: "GST",
      parent: "fy25-26",
      children: ["gstr1", "gstr2", "gstr3b"],
    },
    audit: { id: "audit", name: "Audit", parent: "fy25-26", children: [] },
    gstr1: { id: "gstr1", name: "GSTR-1", parent: "gst", children: [] },
    gstr2: { id: "gstr2", name: "GSTR-2", parent: "gst", children: [] },
    gstr3b: {
      id: "gstr3b",
      name: "GSTR-3B",
      parent: "gst",
      children: ["april", "may", "june"],
    },
    april: { id: "april", name: "April", parent: "gstr3b", children: [] },
    may: { id: "may", name: "May", parent: "gstr3b", children: [] },
    june: { id: "june", name: "June", parent: "gstr3b", children: [] },
    office: {
      id: "office",
      name: "Office",
      parent: "root",
      children: ["policies", "handbooks", "team"],
    },
    policies: {
      id: "policies",
      name: "Policies",
      parent: "office",
      children: [],
    },
    handbooks: {
      id: "handbooks",
      name: "Handbooks",
      parent: "office",
      children: [],
    },
    team: {
      id: "team",
      name: "Team Directory",
      parent: "office",
      children: [],
    },
  };

  // ---------- Helpers ----------
  const toggleFolder = (folderId) => {
    setExpandedFolders((prev) =>
      prev.includes(folderId)
        ? prev.filter((id) => id !== folderId)
        : [...prev, folderId],
    );
  };

  const getFolderPath = (folderId) => {
    const path = [];
    let currentId = folderId;
    while (currentId && currentId !== "root") {
      const folder = folderStructure[currentId];
      if (folder) {
        path.unshift(folder.name);
        currentId = folder.parent;
      } else {
        break;
      }
    }
    return path;
  };

  const navigateToQuickAccess = (category) => {
    setQuickAccessTab(category);
    setSelectedFolder(category);
    if (!expandedFolders.includes(category)) {
      setExpandedFolders((prev) => [...prev, category]);
    }
  };

  const selectFolder = (folderId) => {
    setSelectedFolder(folderId);
  };

  // ---------- Document selection ----------
  const handleCheckboxChange = (id) => {
    setDocuments((prev) =>
      prev.map((doc) =>
        doc.id === id ? { ...doc, checked: !doc.checked } : doc,
      ),
    );
    setSelectedDocs((prev) =>
      prev.includes(id) ? prev.filter((did) => did !== id) : [...prev, id],
    );
  };

  const handleSelectAll = () => {
    const allChecked = documents.every((doc) => doc.checked);
    setDocuments((prev) =>
      prev.map((doc) => ({ ...doc, checked: !allChecked })),
    );
    setSelectedDocs(!allChecked ? documents.map((doc) => doc.id) : []);
  };

  const handleClearSelection = () => {
    setDocuments((prev) => prev.map((doc) => ({ ...doc, checked: false })));
    setSelectedDocs([]);
  };

  // ---------- Move documents with sequential reveal ----------
  const handleMoveDocuments = () => {
    if (selectedDocs.length === 0 || !selectedFolder) return;

    setMovingDocs(true);
    const destinationPath = getFolderPath(selectedFolder);

    // Simulate API call with sparkle delay
    setTimeout(() => {
      setDocuments((prev) =>
        prev.map((doc) =>
          selectedDocs.includes(doc.id)
            ? { ...doc, path: destinationPath }
            : doc,
        ),
      );
      setMovingDocs(false);
      setShowMoveDialog(false);
      setSelectedDocs([]);
      triggerSequentialReveal();
    }, 800);
  };

  const triggerSequentialReveal = () => {
    setShowSequentialReveal(true);
    setRevealStep("complex");
    setTimeout(() => setRevealStep("fading"), 1500);
    setTimeout(() => setRevealStep("simple"), 2500);
    setTimeout(() => setShowSequentialReveal(false), 5000);
  };

  // ---------- Render folder tree (recursive) ----------
  const renderFolderTree = (folderId, level = 0) => {
    const folder = folderStructure[folderId];
    if (!folder) return null;

    // Filter by search
    if (
      folderSearchQuery &&
      !folder.name.toLowerCase().includes(folderSearchQuery.toLowerCase())
    ) {
      const hasMatchingChildren = folder.children.some((childId) => {
        const child = folderStructure[childId];
        return (
          child &&
          child.name.toLowerCase().includes(folderSearchQuery.toLowerCase())
        );
      });
      if (!hasMatchingChildren) return null;
    }

    const isExpanded = expandedFolders.includes(folderId);
    const isSelected = selectedFolder === folderId;
    const isHovered = hoveredFolder === folderId;
    const hasChildren = folder.children.length > 0;

    return (
      <div key={folderId}>
        <motion.div
          onHoverStart={() => setHoveredFolder(folderId)}
          onHoverEnd={() => setHoveredFolder(null)}
          onClick={() => {
            if (hasChildren) toggleFolder(folderId);
            selectFolder(folderId);
          }}
          whileHover={{ x: 2 }}
          className={`relative flex items-center gap-2 px-3 py-2.5 rounded-lg cursor-pointer transition-all duration-300 ${
            isSelected
              ? "bg-gradient-to-r from-cyan-500/20 to-cyan-600/20 border border-cyan-500/30"
              : isHovered
                ? "bg-white/5"
                : "hover:bg-white/5"
          }`}
          style={{ marginLeft: `${level * 16}px` }}
        >
          {isHovered && (
            <motion.div
              layoutId="folder-glow"
              className="absolute inset-0 bg-gradient-to-r from-cyan-500/10 to-transparent rounded-lg"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            />
          )}

          {hasChildren && (
            <motion.div
              animate={{ rotate: isExpanded ? 0 : -90 }}
              transition={{ duration: 0.3 }}
            >
              <ChevronDown
                className={`w-4 h-4 ${isSelected ? "text-cyan-400" : "text-gray-400"}`}
              />
            </motion.div>
          )}
          {!hasChildren && <div className="w-4" />}

          <FolderOpen
            className={`w-4 h-4 ${isSelected ? "text-cyan-400" : "text-gray-500"}`}
          />
          <span
            className={`text-sm ${isSelected ? "text-cyan-300 font-medium" : "text-gray-300"}`}
          >
            {folder.name}
          </span>

          {isSelected && (
            <motion.div
              initial={{ scale: 0, rotate: -180 }}
              animate={{ scale: 1, rotate: 0 }}
            >
              <Sparkles className="w-3 h-3 text-cyan-400" />
            </motion.div>
          )}
        </motion.div>

        <AnimatePresence>
          {hasChildren && isExpanded && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="overflow-hidden"
            >
              {folder.children.map((childId) =>
                renderFolderTree(childId, level + 1),
              )}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    );
  };

  const destinationPath = getFolderPath(selectedFolder);

  // ---------- Render document card (with path chevrons) ----------
  const renderDocumentCard = (doc) => (
    <div key={doc.id}>
      {/* Desktop version (hidden on mobile via CSS) */}
      <div
        className={`items-center gap-4 bg-white rounded-xl p-5 border transition-all cursor-pointer docs_Web ${
          doc.checked
            ? "border-cyan-500 bg-cyan-50/30 shadow-sm"
            : "border-gray-200 hover:border-gray-300"
        }`}
        onClick={(e) => {
          if (!e.target.closest("input") && !e.target.closest("button")) {
            handleCheckboxChange(doc.id);
          }
        }}
      >
        <input
          type="checkbox"
          className="w-5 h-5 accent-cyan-500"
          checked={doc.checked}
          onChange={(e) => {
            e.stopPropagation();
            handleCheckboxChange(doc.id);
          }}
        />
        <div className="text-2xl">{doc.emoji}</div>
        <div className="flex-1">
          <p className="text-gray-900 font-medium mb-2">{doc.name}</p>
          <div className="flex items-center gap-2 flex-wrap">
            {doc.path.map((segment, idx) => (
              <div key={idx} className="flex items-center gap-2">
                <span className="text-xs px-3 py-1 rounded-full bg-gray-100 text-gray-600">
                  {segment}
                </span>
                {idx < doc.path.length - 1 && (
                  <ChevronDown className="w-3 h-3 text-gray-400 rotate-[-90deg]" />
                )}
              </div>
            ))}
          </div>
        </div>
        <span className="text-sm text-gray-500 px-3 py-1 bg-gray-100 rounded-lg">
          {doc.type}
        </span>
        <button
          className="p-2 text-gray-400 hover:text-cyan-600"
          onClick={(e) => {
            e.stopPropagation();
            alert(`Quick preview of ${doc.name}`);
          }}
        >
          <Eye className="w-4 h-4" />
        </button>
      </div>

      {/* Mobile version (your existing DocItem classes) */}
      <div
        className={`DocItem ${doc.checked ? "is-checked" : ""}`}
        onClick={(e) => {
          if (!e.target.closest("input") && !e.target.closest("button")) {
            handleCheckboxChange(doc.id);
          }
        }}
      >
        <input
          type="checkbox"
          className="DocItem_Checkbox"
          checked={doc.checked}
          onChange={(e) => {
            e.stopPropagation();
            handleCheckboxChange(doc.id);
          }}
        />
        <div className="DocItem_Emoji">{doc.emoji}</div>
        <div className="DocItem_Content">
          <p className="DocItem_Title">{doc.name}</p>
          <div className="DocItem_Tags">
            {doc.path.map((segment, idx) => (
              <span key={idx} className="DocItem_Tag">
                {segment}
              </span>
            ))}
          </div>
        </div>
        <span className="DocItem_Type">{doc.type}</span>
        <button
          className="DocItem_PreviewBtn"
          onClick={(e) => {
            e.stopPropagation();
            alert(`Quick preview of ${doc.name}`);
          }}
        >
          <Eye className="DocItem_PreviewIcon" />
        </button>
      </div>
    </div>
  );

  return (
    <section className="Navigate_section">
      {/* Sequential Reveal Overlay */}
      <AnimatePresence>
        {showSequentialReveal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-xl"
          >
            <div className="max-w-4xl w-full px-8">
              {revealStep === "complex" && (
                <motion.div
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 1.05 }}
                  className="text-center"
                >
                  <p className="text-gray-400 text-sm mb-4">
                    Your complex folder structure
                  </p>
                  <div className="bg-gradient-to-b from-gray-900 to-black border border-gray-800 rounded-2xl p-8 mb-6">
                    <div className="space-y-2 text-left">
                      {destinationPath.map((segment, idx) => (
                        <motion.div
                          key={idx}
                          initial={{ opacity: 0, x: -20 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ delay: idx * 0.1 }}
                          className="flex items-center gap-3"
                        >
                          <div className="w-1 h-8 bg-gradient-to-b from-cyan-500 to-cyan-600 rounded-full" />
                          <span className="text-2xl text-gray-100">
                            {segment}
                          </span>
                        </motion.div>
                      ))}
                    </div>
                  </div>
                  <p className="text-xl text-gray-300">
                    Navigate through deep hierarchies...
                  </p>
                </motion.div>
              )}

              {revealStep === "fading" && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="text-center"
                >
                  <p className="text-gray-400 text-sm mb-4">
                    Everything else fades away...
                  </p>
                  <div className="relative">
                    {[...Array(8)].map((_, i) => (
                      <motion.div
                        key={i}
                        initial={{ opacity: 0.5, scale: 1 }}
                        animate={{
                          opacity: 0,
                          scale: 0,
                          x: (i % 2 === 0 ? 100 : -100) * Math.random(),
                          y: (i % 2 === 0 ? -100 : 100) * Math.random(),
                        }}
                        transition={{ duration: 1, delay: i * 0.1 }}
                        className="absolute top-1/2 left-1/2 w-4 h-4 bg-cyan-500/30 rounded-full blur-sm"
                      />
                    ))}
                  </div>
                </motion.div>
              )}

              {revealStep === "simple" && (
                <motion.div
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  className="text-center"
                >
                  <motion.div
                    initial={{ y: 20 }}
                    animate={{ y: 0 }}
                    className="inline-flex items-center gap-2 bg-gradient-to-r from-cyan-500/20 to-cyan-600/20 border border-cyan-500/30 px-6 py-3 rounded-full mb-6"
                  >
                    <Sparkles className="w-5 h-5 text-cyan-400" />
                    <span className="text-cyan-300">Moved Successfully</span>
                  </motion.div>
                  <div className="bg-gradient-to-b from-gray-900 to-black border border-cyan-500/30 rounded-2xl p-8 mb-6">
                    <div className="flex items-center justify-center gap-4">
                      {destinationPath.map((segment, idx) => (
                        <motion.div
                          key={idx}
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ delay: idx * 0.15 }}
                          className="flex items-center gap-4"
                        >
                          <span className="text-3xl text-cyan-300 font-light">
                            {segment}
                          </span>
                          {idx < destinationPath.length - 1 && (
                            <ArrowRight className="w-5 h-5 text-gray-600" />
                          )}
                        </motion.div>
                      ))}
                    </div>
                  </div>
                  <p className="text-2xl text-gray-100 mb-2">
                    This is what you built.
                  </p>
                  <p className="text-lg text-gray-400">
                    Simple. Clean. Organized.
                  </p>
                </motion.div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="max-w-7xl mx-auto">
        <div className="relative">
          {/* Header */}
          <div className="text-center Navigate_mrg">
            {/* <div className="Navigate_Badge">
              <FolderTree className="Navigate_BadgeIcon" />
              <span className="Navigate_BadgeText">Path-Based Organization</span>
            </div> */}
            <h2 className="Navigate_Title">
              Navigate Like
              <br />
              <span className="Navigate_TitleGradient">Your File System.</span>
            </h2>
            <p className="Navigate_Description">
              Familiar folder paths. Powerful organization. Move documents
              anywhere with precision.
            </p>
          </div>

          {/* Main Document Management Panel */}
          <div className="DocsPanel">
            {/* Panel Header */}
            <div className="DocsPanel_Header">
              <div className="DocsPanel_HeaderRow">
                <div>
                  <h3 className="DocsPanel_Title">Your Documents</h3>
                  <p className="DocsPanel_Subtitle">
                    {selectedDocs.length > 0
                      ? `${selectedDocs.length} document(s) selected`
                      : "Select documents to move them"}
                  </p>
                </div>

                <div className="DocsPanel_Actions">
                  {documents.length > 0 && (
                    <button
                      onClick={
                        selectedDocs.length > 0
                          ? handleClearSelection
                          : handleSelectAll
                      }
                      className="DocsPanel_ActionBtn DocsPanel_ActionBtn--secondary"
                    >
                      {selectedDocs.length > 0
                        ? "Clear Selection"
                        : "Select All"}
                    </button>
                  )}
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => setShowMoveDialog(!showMoveDialog)}
                    disabled={selectedDocs.length === 0}
                    className={`DocsPanel_ActionBtn DocsPanel_ActionBtn--primary ${
                      selectedDocs.length === 0 ? "is-disabled" : ""
                    }`}
                  >
                    <Move className="DocsPanel_ActionIcon" />
                    <span>Move Selected ({selectedDocs.length})</span>
                  </motion.button>
                </div>
              </div>
            </div>

            {/* Documents List */}
            <div className="DocsPanel_List">
              {documents.map(renderDocumentCard)}
            </div>

            {/* Theater Mode Move Dialog */}
            <AnimatePresence>
              {showMoveDialog && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.4 }}
                  className="overflow-hidden"
                >
                  <div className="Navigation_File_ToNavigate">
                    {/* relative bg-gradient-to-b from-gray-900 via-black to-gray-900 p-12  */}
                    {/* Spotlight effect */}
                    <div className="Navigation_File_ToNavigate_SubClass" />
                    {/* absolute inset-0 bg-gradient-radial from-cyan-500/5 via-transparent to-transparent opacity-50 */}

                    {/* Close button */}
                    <motion.button
                      whileHover={{ scale: 1.1, rotate: 90 }}
                      whileTap={{ scale: 0.9 }}
                      onClick={() => setShowMoveDialog(false)}
                      className="absolute top-6 right-6 p-2 bg-white/5 hover:bg-white/10 rounded-lg border border-white/10 transition-colors z-10 "
                    >
                      <X className="w-6 h-6 text-gray-400 hover:text-white" />
                    </motion.button>

                    {/* Header */}
                    <motion.div
                      initial={{ opacity: 0, y: -20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="text-center mb-12"
                    >
                      <h4 className="text-4xl text-white mb-3">
                        Choose Destination
                      </h4>
                      <p className="text-gray-400">
                        Navigate your folder tree with precision
                      </p>
                    </motion.div>

                    {/* Glass Card */}
                    <motion.div
                      initial={{ opacity: 0, scale: 0.95 }}
                      animate={{ opacity: 1, scale: 1 }}
                      className="max-w-5xl mx-auto"
                    >
                      <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 shadow-2xl">
                        {/* Quick Access Pills */}
                        <div className="flex items-center gap-3 mb-6">
                          <span className="text-xs text-gray-500 uppercase tracking-wider">
                            Quick Access
                          </span>
                          {[
                            { id: "users", icon: User, label: "Users" },
                            { id: "clients", icon: Users, label: "Clients" },
                            { id: "office", icon: Building, label: "Office" },
                          ].map((tab) => (
                            <motion.button
                              key={tab.id}
                              whileHover={{ scale: 1.05 }}
                              whileTap={{ scale: 0.95 }}
                              onClick={() => navigateToQuickAccess(tab.id)}
                              className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all ${
                                quickAccessTab === tab.id
                                  ? "bg-gradient-to-r from-cyan-500 to-cyan-600 text-white shadow-lg shadow-cyan-500/25"
                                  : "bg-white/5 text-gray-400 hover:bg-white/10 hover:text-gray-300"
                              }`}
                            >
                              <tab.icon className="w-4 h-4" />
                              <span className="text-sm">{tab.label}</span>
                            </motion.button>
                          ))}
                        </div>

                        {/* Search */}
                        <div className="relative mb-6">
                          <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500" />
                          <input
                            type="text"
                            placeholder="Search folders..."
                            value={folderSearchQuery}
                            onChange={(e) =>
                              setFolderSearchQuery(e.target.value)
                            }
                            className="w-full pl-12 pr-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-gray-500 outline-none focus:border-cyan-500/50 focus:bg-white/10 transition-all"
                          />
                        </div>

                        {/* Folder Tree */}
                        <div className="relative">
                          <div className="absolute -inset-4 bg-gradient-to-r from-cyan-500/10 via-cyan-400/5 to-transparent blur-2xl rounded-2xl" />
                          <div className="relative bg-gradient-to-b from-gray-800/80 to-gray-800/60 border border-white/20 rounded-xl p-6 max-h-[400px] overflow-y-auto custom-scrollbar">
                            <div className="space-y-1">
                              {folderStructure.root.children.map((childId) =>
                                renderFolderTree(childId, 0),
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Destination Preview */}
                        <motion.div
                          initial={{ opacity: 0, y: 10 }}
                          animate={{ opacity: 1, y: 0 }}
                          className="mt-6 bg-gradient-to-r from-cyan-500/10 to-cyan-600/10 border border-cyan-500/30 rounded-xl p-4"
                        >
                          <p className="text-xs text-cyan-400 mb-2 uppercase tracking-wider">
                            Destination
                          </p>
                          <div className="flex items-center gap-2 flex-wrap">
                            {destinationPath.length > 0 ? (
                              destinationPath.map((segment, idx) => (
                                <div
                                  key={idx}
                                  className="flex items-center gap-2"
                                >
                                  <span className="text-cyan-300">
                                    {segment}
                                  </span>
                                  {idx < destinationPath.length - 1 && (
                                    <ArrowRight className="w-4 h-4 text-cyan-500/50" />
                                  )}
                                </div>
                              ))
                            ) : (
                              <span className="text-gray-500">
                                Select a destination folder
                              </span>
                            )}
                          </div>
                        </motion.div>
                      </div>
                    </motion.div>

                    {/* Action Buttons */}
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="flex justify-center gap-4 mt-8"
                    >
                      <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={() => setShowMoveDialog(false)}
                        className="px-8 py-3 bg-white/5 border border-white/10 text-gray-300 rounded-xl hover:bg-white/10 transition-all"
                      >
                        Cancel
                      </motion.button>
                      <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={handleMoveDocuments}
                        disabled={!selectedFolder || movingDocs}
                        className={`relative px-8 py-3 rounded-xl transition-all overflow-hidden ${
                          movingDocs
                            ? "bg-cyan-600"
                            : "bg-gradient-to-r from-cyan-500 to-cyan-600 hover:shadow-lg hover:shadow-cyan-500/50"
                        } text-white disabled:opacity-50`}
                      >
                        {movingDocs && (
                          <motion.div
                            className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
                            animate={{ x: ["-100%", "200%"] }}
                            transition={{ duration: 1, repeat: Infinity }}
                          />
                        )}
                        <span className="relative flex items-center gap-2">
                          {movingDocs ? (
                            <>
                              <Sparkles className="w-5 h-5 animate-spin" />
                              Moving...
                            </>
                          ) : (
                            <>
                              <Move className="w-5 h-5" />
                              Move Here
                            </>
                          )}
                        </span>
                      </motion.button>
                    </motion.div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          {/* Features Grid (unchanged) */}
          <div className="mt-12 grid md:grid-cols-4 gap-6">
            {/* ... your existing feature cards ... */}
            <div
              className="bg-gradient-to-b from-white to-gray-50 rounded-xl p-6 border border-gray-200 text-center group hover:border-cyan-500/30
             hover:shadow-lg hover:shadow-cyan-500/5 transition-all Features_Grid_Card"
            >
              <div>
                <FolderTree className="w-8 h-8 text-cyan-600 mx-auto mb-3 group-hover:text-white transition-colors" />
              </div>
              <p className="text-gray-900 mb-1 font-medium group-hover:text-white">
                Visual Tree
              </p>
              <p className="text-sm text-gray-500 group-hover:text-white">
                Navigate with precision
              </p>
            </div>
            <div
              className="bg-gradient-to-b from-white to-gray-50 rounded-xl p-6 border border-gray-200 text-center group hover:border-cyan-500/30 
            hover:shadow-lg hover:shadow-cyan-500/5 transition-all Features_Grid_Card"
            >
              <div>
                <Sparkles className="w-8 h-8 text-cyan-600 mx-auto mb-3 group-hover:text-white transition-colors" />
              </div>
              <p className="text-gray-900 mb-1 font-medium group-hover:text-white">
                Smooth Animations
              </p>
              <p className="text-sm text-gray-500 group-hover:text-white">
                Delightful interactions
              </p>
            </div>
            <div className="bg-gradient-to-b from-white to-gray-50 rounded-xl p-6 border border-gray-200 text-center group hover:border-cyan-500/30 hover:shadow-lg hover:shadow-cyan-500/5 transition-all Features_Grid_Card">
              <div>
                <Eye className="w-8 h-8 text-cyan-600 mx-auto mb-3 group-hover:text-white transition-colors" />
              </div>
              <p className="text-gray-900 mb-1 font-medium group-hover:text-white">
                Clear Paths
              </p>
              <p className="text-sm text-gray-500 group-hover:text-white">
                Always know where you are
              </p>
            </div>
            <div className="bg-gradient-to-b from-white to-gray-50 rounded-xl p-6 border border-gray-200 text-center group hover:border-cyan-500/30 hover:shadow-lg hover:shadow-cyan-500/5 transition-all Features_Grid_Card">
              <div>
                <ArrowRight className="w-8 h-8 text-cyan-600 mx-auto mb-3 group-hover:text-white transition-colors" />
              </div>
              <p className="text-gray-900 mb-1 font-medium group-hover:text-white">
                One-Click Move
              </p>
              <p className="text-sm text-gray-500 group-hover:text-white">
                Instant organization
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Scrollbar Styles (already present, keep) */}
      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 8px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: rgba(6, 182, 212, 0.3);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: rgba(6, 182, 212, 0.5);
        }
      `}</style>
    </section>
  );
}
